import VueRouter, { RouteConfig } from 'vue-router'
import { HomeworkSummaryType } from 'kuaidong-model'

const List = () => import('../views/homework/HomeworkReportList.vue')
const Report = () => import('../views/homework/HomeworkReport.vue')
const Settings = () => import('../views/homework/HomeworkReportSettings.vue')

export const listRoute: RouteConfig = {
  path: '/homework-report-list',
  name: 'homework_report_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业报告订阅',
  },
}

export const settingsRoute: RouteConfig = {
  path: '/homework-report-settings',
  name: 'homework_report_settings',
  component: Settings,
  meta: {
    title: '订阅作业通知',
  },
}

export const reportDailyRoute: RouteConfig = {
  path: '/homework-report-daily',
  name: 'homework_report_daily',
  component: Report,
  props: (route) => ({ ...route.query, ...route.params, type: HomeworkSummaryType.Daily }),
  meta: {
    title: '体育作业统计日报',
  },
}

export const reportWeeklyRoute: RouteConfig = {
  path: '/homework-report-weekly',
  name: 'homework_report_weekly',
  component: Report,
  props: (route) => ({ ...route.query, ...route.params, type: HomeworkSummaryType.Weekly }),
  meta: {
    title: '体育作业统计周报',
  },
}

export const reportDailyByClazzRoute: RouteConfig = {
  path: '/homework-report-daily-by-clazz',
  name: 'homework_report_daily_by_clazz',
  component: Report,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkSummaryType.Daily,
    clazzId: Number(route.query.clazzId),
  }),
  meta: {
    title: '班级作业日报',
  },
}

export const reportWeeklyByClazzRoute: RouteConfig = {
  path: '/homework-report-weekly-by-clazz',
  name: 'homework_report_weekly_by_clazz',
  component: Report,
  props: (route) => ({
    ...route.query,
    ...route.params,
    type: HomeworkSummaryType.Weekly,
    clazzId: Number(route.query.clazzId),
  }),
  meta: {
    title: '班级作业周报',
  },
}

export const reportShareRoute: RouteConfig = {
  path: '/homework-report-share',
  name: 'homework_report_share',
  component: Report,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '作业报告',
    ignoreLogin: true,
  },
}

export default [
  listRoute,
  settingsRoute,
  reportDailyRoute,
  reportWeeklyRoute,
  reportDailyByClazzRoute,
  reportWeeklyByClazzRoute,
  reportShareRoute,
]

export function navigateToHomeworkReportList(
  router: VueRouter,
  type: HomeworkSummaryType | 'weeklyExercisePrescription' | 'vacation' = HomeworkSummaryType.Daily
) {
  router.push({ name: listRoute.name, query: { type } })
}

export function navigateToHomeworkReportSettings(router: VueRouter) {
  router.push({ name: settingsRoute.name })
}

export function navigateToHomeworkReportDaily(router: VueRouter, date: string) {
  router.push({ name: reportDailyRoute.name, query: { date } })
}

export function navigateToHomeworkReportWeekly(router: VueRouter, date: string) {
  router.push({ name: reportWeeklyRoute.name, query: { date } })
}

export function navigateToHomeworkReportDailyByClazz(router: VueRouter, date: string, clazzId: number) {
  router.push({ name: reportDailyByClazzRoute.name, query: { date, clazzId: String(clazzId) } })
}

export function navigateToHomeworkReportWeeklyByClazz(router: VueRouter, date: string, clazzId: number) {
  router.push({ name: reportWeeklyByClazzRoute.name, query: { date, clazzId: String(clazzId) } })
}
